import { render, staticRenderFns } from "./ghImport.vue?vue&type=template&id=0a45958b&scoped=true&"
import script from "./ghImport.vue?vue&type=script&lang=js&"
export * from "./ghImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a45958b",
  null
  
)

export default component.exports